import ArrowCSS from "./arrow.module.css";
const Arrow = ({col1, col2, name}) => {
    return <div className={ArrowCSS.container}>
            <div className={ArrowCSS.parallelogram} style={{backgroundColor: col1}}></div>
            <div className={ArrowCSS.parallelogram} style={{backgroundColor: col2}}></div>
            <div className={ArrowCSS.text}>{name}</div>
        </div>
}

export default Arrow;